export default "__VITE_ASSET__DK_0xIqx__"